import styles from './styles/component.product-card.module.scss';
import { getURLsFromHit } from '../Cards/Product Card/getURLsFromHit';
import { createImage } from '../Cards/Product Card/createImage';
import { createWishlistButton } from '../Cards/Product Card/createWishlistButton';
import { getIconName } from '../Cards/Product Card/getIconName';
import { createBadges } from '../Cards/Product Card/createBadges';
import { isNullOrUndef } from '../js/helpers/isNullOrUndef';
import { seoGetCurrentKeywords } from '../algolia-react/utils/seo.getCurrentKeywords';
import { handleize } from '../js/helpers/handleize';
import { a11yTextVNode } from '../js/a11y';
import { mouseAndWheelHorizontalScrollEvents } from '../js/helpers/mouseAndWheelHorizontalScrollEvents';
import { isNotNullOrUndef } from '../js/helpers/isNotNullOrUndef';
const vn = window.vNode;
class ComponentProductCard extends HTMLElement {
    vNode = null;
    connected = false;
    hit;
    filters;
    imgSizes;
    urls = undefined;
    _clickCallback;
    get _hit() {
        return this.hit;
    }
    set _hit(hit) {
        this.hit = hit;
        if (this.connected && this.filters !== undefined) {
            this.getAndSetURLs();
            this.updateComponent();
        }
    }
    get _filters() {
        return this.filters;
    }
    set _filters(filters) {
        this.filters = filters;
        if (this.connected && this.hit !== undefined) {
            this.getAndSetURLs();
            this.updateComponent();
        }
    }
    get _imageSizes() {
        return this.imgSizes;
    }
    set _imageSizes(sizes) {
        this.imgSizes = sizes;
        this.connected && this.updateComponent();
    }
    getAndSetURLs() {
        if (isNotNullOrUndef(this.hit.layouts)) {
            this.urls = getURLsFromHit({ ...this.filters, item: this.hit });
        }
    }
    createVNode() {
        const seoKws = seoGetCurrentKeywords(this.urls !== undefined ? handleize(this.urls.selectedLayout.type) : false);
        const title = this.hit.title
            .replace(/multi panel|canvas wall art|wall art|personalized/i, '')
            .trim();
        const activeLayoutIndex = this.urls !== undefined ? this.hit.layouts.indexOf(this.urls.selectedLayout) : 0;
        return vn.create('div', {
            class: `pos:r ${styles.wrapper}`
        }, [
            vn.create('div', {
                class: 'pos:r'
            }, [
                createImage({
                    hit: this.hit,
                    title,
                    urls: this.urls,
                    sizes: this.imgSizes,
                    keywords: seoKws,
                    clickCallback: () => {
                        this._clickCallback?.(this.hit);
                    },
                    image3D: this._filters.rooms.length < 1
                }),
                ...(isNotNullOrUndef(this.hit.layouts) && this.hit.layouts.length > 0 && window.matchMedia('(min-width: 1200px)').matches
                    ? [
                        ...(this.hit.layouts.length > 1
                            ? [
                                vn.create('button', {
                                    class: `btn:cleared pos:a t:50 trf:ty:-50 l:0 d:flex ai:center jc:center trs:all:300 ${styles.arrowButton}`,
                                    events: {
                                        click: () => {
                                            this.urls = getURLsFromHit({
                                                ...this.filters,
                                                item: this.hit,
                                                selectedLayout: activeLayoutIndex - 1 < 0
                                                    ? this.hit.layouts[this.hit.layouts.length - 1]
                                                    : this.hit.layouts[activeLayoutIndex - 1]
                                            });
                                            this.updateComponent();
                                        }
                                    }
                                }, [
                                    vn.create('s-svg', { 'data-icon': '#icon--arrow-slider-left' })
                                ]),
                                vn.create('button', {
                                    class: `btn:cleared pos:a t:50 trf:ty:-50 r:0 d:flex ai:center jc:center trs:all:300 ${styles.arrowButton}`,
                                    events: {
                                        click: () => {
                                            this.urls = getURLsFromHit({
                                                ...this.filters,
                                                item: this.hit,
                                                selectedLayout: activeLayoutIndex + 1 > this.hit.layouts.length - 1
                                                    ? this.hit.layouts[0]
                                                    : this.hit.layouts[activeLayoutIndex + 1]
                                            });
                                            this.updateComponent();
                                        }
                                    }
                                }, [
                                    vn.create('s-svg', { 'data-icon': '#icon--arrow-slider-right' })
                                ])
                            ]
                            : []),
                        vn.create('div', {
                            class: `d:flex jc:between pos:a l:0 w:100 ${styles.buttonsRow}`
                        }, [
                            vn.create('div', {
                                class: 'fx:1 d:flex ov:h'
                            }, [
                                vn.create('ul', {
                                    class: `list:none trs:all:300 maw:100 scrbar:none ov:x:a ov:y:h ${styles.layouts}`,
                                    ...(window.matchMedia('(min-width: 1024px)').matches &&
                                        {
                                            events: {
                                                mousedown: mouseAndWheelHorizontalScrollEvents.mousedown
                                            }
                                        })
                                }, this.hit.layouts.map((layout, i) => {
                                    const iconName = getIconName(layout.name);
                                    return vn.create('li', {
                                        key: layout.name,
                                        data: {
                                            gaEvent: `["Product card", "click", "Switch layout icon: ${layout.name}"]`
                                        }
                                    }, [
                                        vn.create('button', {
                                            class: `btn:cleared d:flex ai:center jc:center bdrs:1 trs:all:300 hover:bxsh:3 ${styles.layoutButton}`,
                                            ...(i === activeLayoutIndex
                                                ? { 'data-active': '' }
                                                : {
                                                    events: {
                                                        click: () => {
                                                            this.urls = getURLsFromHit({ ...this.filters, item: this.hit, selectedLayout: layout });
                                                            this.updateComponent();
                                                        }
                                                    }
                                                })
                                        }, [
                                            a11yTextVNode('Switch layout to ' + layout.name),
                                            vn.create('s-svg', { class: styles.layoutButtonIcon, 'data-icon': `#${iconName}` })
                                        ])
                                    ]);
                                }))
                            ]),
                            vn.create('button', {
                                class: `btn:cleared lh:0 bdrs:1 hover:bxsh:3 trs:all:300 ${styles.layoutButton} ${styles.quickViewButton}`,
                                events: {
                                    click: () => {
                                        void import('../Cards/Product Card/quickView').then(({ quickView }) => {
                                            this.urls !== undefined && quickView(this.hit, this.urls, (selectedLayout) => {
                                                this.urls = getURLsFromHit({ ...this.filters, item: this.hit, selectedLayout });
                                                this.updateComponent();
                                            });
                                        });
                                    }
                                }
                            }, [
                                vn.create('s-svg', {
                                    class: styles.quickViewButtonIcon,
                                    'data-icon': '#icon--magnifying-plus'
                                })
                            ])
                        ])
                    ]
                    : [])
            ]),
            vn.create('div', {
                class: styles.titleWrapper
            }, [
                vn.create('span', {
                    class: `fw:700 lts:001 ${styles.title}`
                }, [title]),
                createWishlistButton(this.hit),
                ...(isNullOrUndef(this.hit.artist_name) || this.hit.artist_name.length < 1
                    ? []
                    : [vn.create('a', {
                            href: `/collections/${handleize(this.hit.artist_name)}-wall-art`,
                            class: `ff:abril-display text:italic text:capitalize ${styles.artist}`
                        }, [this.hit.artist_name])]),
                ...createBadges(this.hit)
            ])
        ]);
    }
    updateComponent() {
        const nVNode = this.createVNode();
        vn.patch(this.vNode, nVNode, this);
        this.vNode = nVNode;
    }
    connectedCallback() {
        if (this._hit !== undefined && this._filters !== undefined) {
            this.hit = this._hit;
            this.filters = this._filters;
            this.getAndSetURLs();
            this.updateComponent();
        }
        this.connected = true;
    }
}
window.customElements.define('product-card-new-component', ComponentProductCard);
